import { getLink } from "../../../utils/utils";

import translator from "./translator";

const content = {
  esp: (
    `
    <h4 class="mb-3 bold text-center">Mirinda aŭtuno</h4>

    <div class="poem">
      <p class="poem-block mb-3">
        Oktobro, vi belegas<br/>
        En ruĝe-flava vest’.<br/>
        Koloroj viaj regas<br/>
        Aŭtune kun majest’.<br/>
        Jen flamas la acero<br/>
        Per ruĝa foliar’,<br/>
        Sed restas efemero<br/>
        Festen’ aŭtuna, ĉar<br/>
        Ne longas belvetero.<br/>
        Ho ve, la tuta or’<br/>
        Forfalos al la tero<br/>
        Kaj ĝemos mia kor’.<br/>
        Ne hastu, tempo kruda,<br/>
        Alveni kun malvarm’,<br/>
        Kun la branĉaro nuda<br/>
        Kaj pluva-neĝa svarm’.<br/>
        Vi falu lantaj, lantaj<br/>
        Oraĵoj de la alt’:<br/>
        Timigas min la gantoj<br/>
        Kaj vintra lana palt’.
      
      </p>
    </div>
  `
  )
}

const itemName = {
  esp: 'Elza Beskow'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemDate: '13 octobro 2023',
    itemContent: content.esp,
    itemTranslator: translator.esp
  }
}

export default item;

